module.exports = __webpack_public_path__ + "img/zhongbangImg.8a93fba6.png";